import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';
import { Stack, Typography } from '@mui/material';
import { Blacklist_New } from 'features/co-pilot/company-blacklists/company-blacklist.types';
import PaiDotLoader from 'features/ui/base-components/pai-dot-loader';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles } from 'tss-react/mui';
import GlobalBlacklistsTable from './global-blacklists-table';

interface Props {
  globalBlacklists: Blacklist_New[];
  globalBlacklistsLoading: boolean;
  selectedGlobalBlacklists: string[];
  blacklistSyncLoading: boolean;

  handleSelectedBlacklistsChange(blacklist: Blacklist_New): () => void;
}

const GlobalBlacklists: React.FC<Props> = ({
  globalBlacklists,
  globalBlacklistsLoading,
  selectedGlobalBlacklists,
  blacklistSyncLoading,
  handleSelectedBlacklistsChange,
}) => {
  const { classes } = useStyles();
  const { t } = useTranslation();

  return (
    <Stack className={classes.globalBlacklists} gap={2}>
      <Stack direction={'row'} alignItems={'center'} gap={1}>
        <ArrowRightAltIcon className={classes.arrow} />
        <Typography className={classes.boldText}>{t('activateExistingBlacklists')}</Typography>
      </Stack>
      {globalBlacklistsLoading ? (
        <PaiDotLoader />
      ) : (
        <GlobalBlacklistsTable
          blacklists={globalBlacklists}
          selectedGlobalBlacklists={selectedGlobalBlacklists}
          blacklistSyncLoading={blacklistSyncLoading}
          handleSelectedBlacklistsChange={handleSelectedBlacklistsChange}
        />
      )}
    </Stack>
  );
};

const useStyles = makeStyles()((theme) => ({
  globalBlacklists: {
    height: '100%',
    overflow: 'hidden',
  },
  boldText: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: 'bold',
  },
  arrow: {
    fontSize: theme.typography.pxToRem(32),
    color: theme.palette.primary.main,
  },
}));

export default GlobalBlacklists;
